import React from 'react';

const Services = () => {
    const services = [
        {
            icon: 'code',
            color: 'blue',
            title: 'Fullstack Web Development',
            description: 'Building comprehensive web solutions. I handle everything from the database architecture to the pixel-perfect frontend interface using the Express.js ecosystem.'
        },
        {
            icon: 'dashboard',
            color: 'purple',
            title: 'UI Implementation',
            description: 'Translating Figma designs into responsive, interactive code with Tailwind CSS, ensuring fidelity to the original vision.'
        },
        {
            icon: 'dns',
            color: 'orange',
            title: 'Backend Engineering',
            description: 'Robust API design, database modeling (NonSQL), and secure authentication systems built for scalability and performance.'
        },
       
    ];

    return (
        <section className="py-20  max-w-6xl mx-auto px-6">
            <div className="container mx-auto">
                <div className="text-center mb-16">
                    <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">Beyond Just Coding</h2>
                    <p className="text-gray-500 dark:text-gray-400 max-w-2xl mx-auto">
                        I provide holistic web solutions, applying Gestalt principles to both design and code architecture.
                    </p>
                </div>
                <div className="grid md:grid-cols-2 gap-6">
                    {services.map((service, index) => (
                        <div key={index} className={`bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark p-8 rounded-2xl hover:border-${service.color === 'primary' ? 'primary' : service.color + '-500'}/50 transition-colors group`}>
                            <div className={`w-12 h-12 bg-${service.color === 'primary' ? 'primary' : service.color + '-500'}/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-${service.color === 'primary' ? 'primary' : service.color + '-500'}/20 transition-colors`}>
                                <span className={`material-icons-round text-${service.color === 'primary' ? 'primary' : service.color + '-500'}`}>{service.icon}</span>
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">{service.title}</h3>
                            <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed">
                                {service.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;